import { Outlet } from '@buzola/router'
import { ContemberClient } from '@contember/react-client'
import { Layout } from '~/entrypoint/components/layout'
import { loginEntrypointConfig } from '~/entrypoint/config'
import { LoginConfigProvider } from '~/entrypoint/contexts/login'

export default function LoginLayout() {
	return (
		<ContemberClient apiBaseUrl={loginEntrypointConfig.apiBaseUrl} loginToken={loginEntrypointConfig.loginToken}>
			<LoginConfigProvider
				appUrl={loginEntrypointConfig.appUrl}
				hasTokenFromEnv={loginEntrypointConfig.hasTokenFromEnv}
				idps={loginEntrypointConfig.idps}
				magicLink={loginEntrypointConfig.magicLink}
			>
				<Layout>
					<Outlet />
				</Layout>
			</LoginConfigProvider>
		</ContemberClient>
	)
}
